module.exports = __webpack_public_path__ + "97493d3f11c0a3bd5cbd959f5d19b699.woff2";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/fontawesome-webfont.woff2?v=4.3.0
// module id = 1090
// module chunks = 0